<page-header title="COMPOUNDS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info m-0"
        translationEditableDirective="CREATE_COMPOUND"
        *ngxPermissionsOnly="['CREATE_COMPOUND']"
        >{{ 'CREATE_COMPOUND' | translate }}</a
      >
    </div>
  </ng-template>
  <ng-template #addonRight>
    <form>
      <input
        [translationEditableModalDirective]="['SEARCH']"
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
      />
    </form>
  </ng-template>
  <ng-template let-row="row" #code>
    <div class="buttons">
      <a [routerLink]="['/compounds/', row.get('id'), 'general']">{{
        row.get('code')
      }}</a>
    </div>
  </ng-template>
</app-table>
